import * as React from 'react';
import styled from 'styled-components';

export default function Footer() {
  const StyledFooter = styled.div`
    background-color: #003b5c;
    height: 30px;
    display: flex;
    justify-content: right;
  `;

  const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0 20px;
    justify-content: flex-end;
  `;

  const StyledItem = styled.div`
    position: relative;
    color: #fff;
    font-family: 'Roboto', serif;
    border-left: 1px solid #fff;
    padding-left: 20px;
    :first-child {
      border-left: 0;
    }
    @media (max-width: 480px) {
      a {
        font-size: 12px;
      }
      padding-left: 4px;
      font-size: 12px;
    }
    a {
      text-decoration: none;
      color: #fff;
    }
  `;

  return (
    <StyledFooter>
      <StyledContainer>
        <StyledItem> &#169; Stratasys 2022</StyledItem>
        <StyledItem>
          <a href="https://www.stratasys.com/en/legal/legal-information/">
            Legal information
          </a>
        </StyledItem>
        <StyledItem>
          <a href="https://www.stratasys.com/en/legal/privacy-policy/">
            Privacy Policy
          </a>
        </StyledItem>
      </StyledContainer>
    </StyledFooter>
  );
}
